import React from 'react';
import sprite from '../img/sprite.svg';

const Icon = (props) => (
  <svg viewBox='0 0 1 1' {...props} key={props.svgName} style={{background: 'none', ...props.style}}>
    <use xlinkHref={`${sprite}#SVG_${props.svgName}`} fill={props.color}></use>
  </svg>
);

export default Icon;